import React from 'react'

function VolumeSlider(props) {
	let value = props.value || 0
	let setValue = props.setValue || function() {}
	let scale = props.scale || 1
	let style = props.style || {}
	let color = props.color || 'white'
	return (
		<div style={props.style}>
			<div style={{position: 'relative', height: '100%', width: '37px'}}>
				<input
					type="range"
					min="0"
					max="1"
					step="0.0001"
					className="sliderVertical"
					orient="vertical"
					style={{width: '37px', height: '100%', position: 'absolute', left: '-2px', top: '-2px', opacity: 0, zIndex: 800}}
					onInput={function(event) {setValue(event.target.value*scale)}}
				/>
				{Array.apply(0, Array(props.levels)).map(function (num, i) {
					let on = value/scale > (props.levels-i-0.5)/props.levels
					return (
						<div key={i} style={{width: '37px', height: '17px', background: color, marginTop: i>0?'7px':'0px'}}>
							<div style={{width: '100%', height: '100%', background: 'rgba(0, 0, 0, 0.8)', opacity: on?'0':'1'}}></div>
						</div>
					)
				})}
			</div>
		</div>
	)
}

export default VolumeSlider
